import cloneDeep from "lodash.clonedeep";
import { imageModel } from "pages/application/opportunities/create/elements/createOpportunityDetails/CreateOpportunityDetails";
import { useCallback, useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { Button, FilePicker } from "stories";
import { v4 as uuidv4 } from "uuid";
import ImageUploader from "../imageUploader/ImageUploader";
import ImageData from "./elements/imageData/ImageData";
import classes from "./ImageModal.module.scss";

const ImageModal = ({ visibility, setVisibility, files, onAccept }) => {
  const [tmpFiles, setTmpFiles] = useState(cloneDeep(files));
  useEffect(() => {
    setTmpFiles(cloneDeep(files));
  }, [files]);
  const [selectedImage, setSelectedImage] = useState(0);
  const handleSelectImage = useCallback(
    (index) => {
      setSelectedImage(index);
    },
    [setSelectedImage]
  );
  useEffect(() => {
    if (visibility >= 0) {
      setSelectedImage(visibility);
    }
  }, [visibility]);

  const updateLabel = (label) => {
    tmpFiles[selectedImage].label = label;
    setTmpFiles([...tmpFiles]);
  };

  const updateDescription = (description) => {
    tmpFiles[selectedImage].description = description;
    setTmpFiles([...tmpFiles]);
  };

  const updateCover = (cover) => {
    if (cover) {
      for (const index in tmpFiles) {
        if (tmpFiles[index].cover) {
          tmpFiles[index].cover = false;
        }
      }
    }
    tmpFiles[selectedImage].cover = cover;
    setTmpFiles([...tmpFiles]);
  };
  const handleOnAccept = () => {
    onAccept(tmpFiles);
    setVisibility(false);
  };
  const handleDecline = () => {
    setTmpFiles(cloneDeep(files));
    setVisibility(false);
  };
  const onUploadFile = (files) => {
    setTmpFiles([
      ...tmpFiles,
      ...files.map((filename) => {
        return {
          key: uuidv4(),
          ...imageModel,
          filename,
        };
      }),
    ]);
  };
  return (
    <div>
      <Modal
        show={visibility >= 0}
        onHide={() => setVisibility(false)}
        size={"lg"}
        centered
      >
        <Modal.Header closeButton>
          <div className={"modal-title"}>Upload Images</div>
        </Modal.Header>
        <Modal.Body className={"mt-0"}>
          <Row>
            <Col>
              <FilePicker
                multiple={true}
                onSelect={onUploadFile}
                showSelectedFiles={false}
                type="image"
              />
              <div className={classes["image-list-wrapper"]}>
                {tmpFiles.map((item, index) => (
                  <ImageUploader
                    filename={item.filename}
                    key={item.key || item.id}
                    isCover={item.cover}
                    selected={selectedImage === index}
                    setSelectedImage={handleSelectImage.bind(null, index)}
                  />
                ))}
              </div>
            </Col>
            <Col>
              {tmpFiles[selectedImage] && (
                <ImageData
                  key={tmpFiles[selectedImage].id}
                  data={tmpFiles[selectedImage]}
                  updateLabel={updateLabel}
                  updateDescription={updateDescription}
                  updateCover={updateCover}
                />
              )}
              <div className="d-flex justify-content-end py-4">
                <div className="w-50 me-2">
                  <Button label={"Cancel"} outline onClick={handleDecline} />
                </div>
                <div className="w-50">
                  <Button label={"Accept"} onClick={handleOnAccept} />
                </div>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ImageModal;
